module.exports = require("./createClass.js");


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/helpers/create-class.js
// module id = 109
// module chunks = 13